const moment = require('moment');

import userService from '@common/services/user.service';
import historyService from '@common/services/history.service';

export default {
    setUser(context, userData) {
        context.commit('setUser', userData);
    },
    setToken(context, token) {
        context.commit('setToken', token);
    },
    setInPage(context, inPage) {
        context.commit('setInPage', inPage);
    },
    setIsLoggedIn(context, isLoggedIn) {
        context.commit('setIsLoggedIn', isLoggedIn);
    },
    setStartDate(context, startDate) {
        context.commit('setStartDate', startDate);
    },
    setIsFetchedStartDate(context, isFetchedStartDate) {
        context.commit('setIsFetchedStartDate', isFetchedStartDate);
    },
    setHistory(context, isFetchedStartDate) {
        context.commit('setHistory', isFetchedStartDate);
    },
    async fetchUser(context, additionalConfig = {}) {
        try {
            const res = await userService.getUserData(
                context.state.token,
                additionalConfig,
            );
            const {
                data: { rows: userData },
            } = res;
            context.dispatch('setUser', userData);
            context.dispatch('setIsLoggedIn', true);
            setTimeout(
                () => context.dispatch('fetchUser', context.state.token),
                process.env.VUE_APP_CHECK_USER_TIME,
            );
        } catch (error) {
            console.error(error);
            context.dispatch('setUser', { fullname: null, balance: 0 });
            context.dispatch('setIsLoggedIn', false);
            context.dispatch('setIsFetchedStartDate', false);
        }
    },
    async fetchStartDate(context) {
        try {
            if (!context.getters.isFetchedStartDate) {
                const res = await userService.getStartDate();
                context.dispatch('setStartDate', res.data.rows.date);
                context.dispatch('setIsFetchedStartDate', true);
            }
        } catch (error) {
            console.error(error);
            context.dispatch('setStartDate', '');
        }
    },
    async fetchUserHistory(context) {
        try {
            if (context.state.token) {
                let shouldContinue = true;
                let page = 1;
                let result = [];
                while (page <= 10 && shouldContinue) {
                    const betHistory = await historyService.getHistoryData(
                        context.state.token,
                        moment(new Date())
                            .subtract(20, 'day')
                            .format('DD-MM-YYYY'),
                        moment(new Date()).format('DD-MM-YYYY'),
                        20,
                        page,
                    );
                    if (
                        betHistory.data.rows &&
                        betHistory.data.rows.length !== 0
                    ) {
                        result = result.concat(betHistory.data.rows);
                    } else {
                        shouldContinue = false;
                    }
                    page++;
                }
                context.dispatch('setHistory', result);
            }
        } catch (error) {
            console.error(error);
            context.dispatch('setHistory', null);
        }
    },
};
